import React from "react";
import { createRoot } from "react-dom/client";
import { WrappedIntlProvider } from "./react-components/wrapped-intl-provider";
import registerTelemetry from "./telemetry";
import "./utils/theme";
import { HomePage } from "./react-components/home/HomePage";
import { AuthContextProvider } from "./react-components/auth/AuthContext";
import "./react-components/styles/global.scss";
import { ThemeProvider } from "./react-components/styles/theme";
import { store } from "./utils/store-instance";
import { PreviewExperience } from "./react-components/preview/PreviewExperience";

registerTelemetry("/home", "Hubs Home Page");

window.APP = { store };

function HomeRoot() {
  const isInteractivePreview =
    (process.env.IS_UI_PREVIEW || window.location.port === "4173") &&
    new URLSearchParams(window.location.search).has("demo");

  return (
    <WrappedIntlProvider>
      <ThemeProvider store={store}>
        <AuthContextProvider store={store}>
          {isInteractivePreview ? <PreviewExperience /> : <HomePage />}
        </AuthContextProvider>
      </ThemeProvider>
    </WrappedIntlProvider>
  );
}

const container = document.getElementById("home-root");
const root = createRoot(container);
root.render(<HomeRoot />);
